.section {
  margin-bottom: 16px;
}

/* 空状态占住图表的高度，卡片不塌陷 */
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 350px;
  margin: 0;
}

.todayActive {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 16px;
}

.todayActiveValue {
  font-size: 24px;
  color: var(--ant-color-text-heading);
}

.sectionTitle {
  display: block;
  margin-bottom: 16px;
}

.activityTime,
.activityUser {
  margin-right: 8px;
}
